
import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import WrapSelectedNodesWithMuteOperation from "models/audioEditor/sequencerOperation/WrapSelectedNodesWithMuteOperation";
import StartWrapSequencerNode from "models/audioEditor/sequencerNodes/StartWrapSequencerNode";
import RSVP from "rsvp";

const DeleteWrapWithMuteNodesOperation = WrapSelectedNodesWithMuteOperation.extend({
    idAttribute: "id",

    constructor: function(attributes, options) {
        WrapSelectedNodesWithMuteOperation.apply(this, [attributes, options]);
    },

    execute: function(startOrEndMuteWrapSequencerNode){
        const startWrapMuteNode = startOrEndMuteWrapSequencerNode.getStartWrappedNode();
        const endWrapMuteNode = startOrEndMuteWrapSequencerNode.getEndWrappedNode();
        let startSequencerNodeToWrap = null;
        let endSequencerNodeToWrap = null;

        if (startOrEndMuteWrapSequencerNode instanceof StartWrapSequencerNode) {
            startSequencerNodeToWrap = startOrEndMuteWrapSequencerNode;
            endSequencerNodeToWrap = startOrEndMuteWrapSequencerNode.getEndWrapSequencerNode();
        } else {
            startSequencerNodeToWrap = startOrEndMuteWrapSequencerNode.getStartWrapSequencerNode();
            endSequencerNodeToWrap = startOrEndMuteWrapSequencerNode;
        }

        this.revertWrapNodeCreation(startOrEndMuteWrapSequencerNode);

        this.getSequencer().getHistoryManagement().addDeleteWrapWithMuteLog(
            startWrapMuteNode,
            endWrapMuteNode,
            startSequencerNodeToWrap,
            endSequencerNodeToWrap
        );
    },

    undo: function(sequencerOperationDeleteWrapWithMuteLog){
        return WrapSelectedNodesWithMuteOperation.prototype.redo.apply(this, [sequencerOperationDeleteWrapWithMuteLog]);
    },

    redo: function(sequencerOperationDeleteWrapWithMuteLog){
        return WrapSelectedNodesWithMuteOperation.prototype.undo.apply(this, [sequencerOperationDeleteWrapWithMuteLog]);
    }
});

export default DeleteWrapWithMuteNodesOperation;
